<template>
    <div>
        <template
            v-for="item in items"
            :key="item.id"
        >
            <div class="sim-basic-list__item">
                <span>
                    {{ item[leftColumnKey] }}
                </span>
                <span>
                    {{ item[rightColumnKey] }}
                </span>
            </div>
            <hr class="my-4">
        </template>
    </div>
</template>

<script lang="ts" setup>
const {
    items,
    leftColumnKey,
    rightColumnKey,
} = defineProps<{
    items: any[],
    leftColumnKey: string,
    rightColumnKey: string
}>()
</script>

<style lang="scss" scoped>
.sim-basic-list__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    column-gap: 1rem;

    @include sim-text-large;
    color: $sim-c-primary-900;
}
</style>
